import api from "./api";

const AwsChatbotAPI = {
    getChatSessionByUserId: () => api.get(`/aws-chatbots/session`),
    getChatHistoryBySessionId: (params) => api.get(`/aws-chatbots/chat-history/?${params}`),
    updChatSessionTitle: (data) => api.put(`/aws-chatbots/session/update-title`, data),
    insChatSessionTitle: (data) => api.post(`/aws-chatbots/session/insert-title`, data),
    insAwsChatHistory: (data) => api.post(`/aws-chatbots/chat-history/insert`, data),
    getUserCountChat: () => api.get(`/aws-chatbots/count-chat`),
    inCreaseUserCountChat: () => api.post(`/aws-chatbots/count-chat/increase`),
    textToSpeechAsync: (data) => api.post(`/aws-chatbots/tts`, data, {
        responseType: "blob"
    }),
    speechToTextAsync: (data) => api.post(`/aws-chatbots/stt`, data),
    languageDetectedAsync: (data) => api.post(`/aws-chatbots/language-detected`, data),
    translateLanguageAsync: (data) => api.post(`/aws-chatbots/translate-language`, data),
};

export default AwsChatbotAPI;